import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.4/js/sparta-events-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
class SpartaGlobalFunctions {
  constructor() {
    // console.log('%cstore ', 'color: lime', spartaStore);
    spartaEventsUtility.sub(spartaEventsUtility.EVENTS.SPA_PARAMS_LOADED, (spaParams) => {
      this.spaParams = spaParams.data;
    });
  }

  /**
   * @param {string} name Name of the cookie to search for
   * @return {string} Cookie Value
   */
  spartaGetCookie(name) {
    let returnvalue = '';
    const search = `${name}=`;

    if (document.cookie.length > 0) {
      let offset = document.cookie.indexOf(search);
      if (offset !== -1) {
        offset += search.length;
        let end = document.cookie.indexOf(';', offset);
        if (end === -1) {
          end = document.cookie.length;
        }
        returnvalue = unescape(document.cookie.substring(offset, end));
      }
    }

    return returnvalue;
  }

  /**
   * @param {string} name Name of the cookie to set
   * @param {string} value Value to set the cookie at
   * @param {string} days Number of days to store the cookie
   * @param {string} domain The domain to store the cookie on/for
   * @return {boolean}
   */
  spartaSetCookie(name = '', value = '', days = false, domain = false) {
    let expires = '';

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toGMTString()}`;
    }

    const domainStr = (domain ? ';domain=.bankofamerica.com' : '');
    document.cookie = `${name}=${value}${expires}${domainStr}; path=/`;

    return true;
  }

  /**
   * @param {string} name Name of the URL parameter to get
   * @return {string|Null} returns the value of the URL parameter or null if not found
   */
  getUrlParam(name) {
    if (window.location.search.indexOf('?') < 0) {
      return null;
    }
    let result = null;
    const paramList = window.location.search.split('?')[1].split('&');
    const paramObj = {};

    paramList.forEach(paramPair => {
      const splitPair = paramPair.split('=');

      // check for duplicate param names
      if (paramObj[splitPair[0]]) {
        paramObj[splitPair[0]] = [paramObj[splitPair[0]]];
        paramObj[splitPair[0]].push(splitPair[1]);
      } else {
        paramObj[splitPair[0]] = splitPair[1];
      }
    });

    if (paramObj[name]) {
      result = decodeURIComponent(paramObj[name]);
    }

    return result;
  }

  /**
   * getGlobalParams Lookup and return string from global language obj
   * the spaParams object is output in the rendered HTML via layout-support-footer.hbs
   */
  getGlobalParams(key) {
    const htmlLang = document.querySelector('html').getAttribute('lang');
    const lang = htmlLang ? htmlLang.toLowerCase().split("-")[0] : 'en';
    const result = this.spaParams.global[lang].globalJs[key] || '';

    return result;
  }

  /**
   * getLanguage return global language string
   */
  getLanguage() {
    return this.spaParams.language;
  }

  /**
   * getSpaParams return spaParams object
   */
  getSpaParams() {
    return this.spaParams;
  }

  /**
   * Reformat phone numbers on mobile devices based on class: '.spa-mobile-tel'
   * @param  {nodelist} context - list of elements to process
   * @example
   *  <span class="spa-fn spa-mobile-tel">980-555-1234</span>
   */
  mobilePhoneFormatHelper(elements) {
    const els = [...elements] || document.querySelectorAll('.spa-mobile-tel');
    els.forEach(el => {
      if (el.getAttribute('data-mobile-phone-formatted')) {
        return;
      }
      let phone = el.innerHTML.replace(/\D/g, '');
      phone = `1${phone}`;
      el.innerHTML = `<a href="tel:+${phone}">${el.innerHTML}</a>`;
      el.setAttribute('data-mobile-phone-formatted', '1');
    });
  }
}

export default new SpartaGlobalFunctions();
